export default "/images/3d750a6a90cccc68e304b90faa8404f7.avif";